import PropTypes from 'prop-types';
import { styled } from '@activebrands/core-web/libs/styletron';
import responsiveTextStyles from '@activebrands/core-web/utils/responsive-text-styles';

const StyledParagraph = styled('p');

const Paragraph = ({
    $style = {},
    as = 'p',
    children,
    'data-selector': dataSelector,
    fontKeys = 'Primary/16_120_-1',
}) => {
    const fontStyle = responsiveTextStyles(fontKeys);
    const style = { ...fontStyle, ...$style };

    return (
        <StyledParagraph $as={as} $style={style} data-selector={dataSelector}>
            {children}
        </StyledParagraph>
    );
};

Paragraph.propTypes = {
    $style: PropTypes.object,
    as: PropTypes.string,
    children: PropTypes.node,
    'data-selector': PropTypes.string,
    fontKeys: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
};

export default Paragraph;
